import { render, staticRenderFns } from "./NewSelect.vue?vue&type=template&id=39c15590&scoped=true"
import script from "./NewSelect.vue?vue&type=script&lang=js"
export * from "./NewSelect.vue?vue&type=script&lang=js"
import style0 from "./NewSelect.vue?vue&type=style&index=0&id=39c15590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c15590",
  null
  
)

export default component.exports